<template>
  <v-card class="pa-10" height="100%">
    <slot />
  </v-card>
</template>

<script>
export default {
  name: "MainCard",
  data: () => ({}),
};
</script>

<style></style>
